import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Form from "../../../../components/forms/index";
import url from "../../../../config/axios";
import { FailedNotify, SuccessNotify } from "../../../../constants/tostify";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
const UsedItems = () => {
  const navigate = useNavigate();
  const [shopCategoryone, setShopCategoryone] = useState();
  const { name } = useSelector((state) => state.user);
  const [displayimg, setDisplayimg] = useState();
  const [isloading, setIsloading] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const onDrop = async (acceptedFiles) => {
    try {
        setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setCreateShop((createShop) => ({
        ...createShop,
        image: abc
      }));

      setDisplayimg(abc);

    } catch (error) {
      FailedNotify("Failed! Try Again");
    }
    finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [selectshop, setSelectshop] = useState({
    shopCategory: ""
  });
  const Shopdatas = (e) => {
    setSelectshop((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = selectshop?.shopCategory[1];
  const categoryid = selectshop?.shopCategory[0];

  localStorage.setItem('mycategory', categoryName);




  const [createShop, setCreateShop] = useState({
    userid: name._id,
    shopname: "",
    shopaddress: "",
    shoplicense: "",
    contact: "",
    shopCategory: "",
    image: [""],
    isFoodShop: false,
    marketPlace: "",
    businessType: "usedShop",
    description: "",
    status: true,
  });

  useEffect(() => {
    setCreateShop((createShop) => ({
      ...createShop,
      shopCategory: categoryid
    }
    ))
  }, [categoryid]);


  useEffect(() => {
    url
      .get("category/type/?type=usedShop&parentCategory=")
      .then(async (response) => {
        if (response?.data?.success) {
          setShopCategoryone(response?.data?.data?.Category)
        }
      })
      .catch((error) => {
      });
  }, [])
  const PostShopData = (e) => {
    setIsloading(true);
    e.preventDefault();

    let submitData = { ...createShop };
    if (!submitData.shopCategory || submitData.shopCategory === "Select Category") {
      delete submitData.shopCategory;
    }

    url
      .post("shop/", submitData)
      .then(async (response) => {
        if (response?.data?.success) {
          setIsloading(false);
          setTimeout(() => {
            SuccessNotify("Form used-items Created Successfully");
            navigate(
              `/rawmaterial-useditem/${response?.data?.data?._id}`
            );
          }, 1000);
        }
      })
      .catch((error) => {
        setIsloading(false);
        const backendMessage = error?.response?.data?.message || error?.message || "Failed To Create Shop";
        FailedNotify(backendMessage);
      });
  };
  if (isloading) {
    return (
      <div>
        <Loader heightsetting="screenHeight" />
      </div>
    );
  }
  return (
    <>
      <Form
        title="Fill to create Used Items"
        butn="Create"
        navigateTo="/rawmaterial-useditem"
        back="/useditems-integrate"
        CreateHandler={PostShopData}
        setCreateShop={setCreateShop}
        createShop={createShop}
        shopCategoryone={shopCategoryone}
        getInputProps={getInputProps}
        getRootProps={getRootProps}
        displayimg={displayimg}
        setDisplayimg={setDisplayimg}
        Shopdatas={Shopdatas}
        isUploading={isUploading}           
uploadProgress={uploadProgress} 
      />
    </>
  );
};
export default UsedItems;
